import React, { useMemo,  useContext } from 'react';
import { removeValueFromArray } from '../helpers/global'
import { format_date_full, format_dates } from '../helpers/dates'

import Context from "../context/context";
import Pagination from './Pagination';

const FilterTotals = React.lazy(() => import('./FilterTotals'));

import Slot from './Slot';

const ListView = props => {
  const {startDate, endDate, filterView, filteredItems, activeFilters, setActiveFilters, pagination, totalItems, currentPage, setCurrentPage} = useContext(Context);
  const pagedItems = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pagination.perpage;
    const lastPageIndex = firstPageIndex + pagination.perpage;
    return filteredItems.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, filteredItems]);

  let selectedFilters = [];

  for (const filter_name in activeFilters) {

    const filter = activeFilters[filter_name];
    const titles = filter.selectedTitles;
    const values = filter.value;
    if (values.length && filter.name != "calendar" && filter.position != "top" ){
      if (filter.type == "hidden" || filter.name == "search"){
        let selected = {
          title: filter.value,
          value: filter.value
        }
        selectedFilters.push(selected)
      } else {
        for (let i = 0; i < values.length; i++){
          const title = titles[i],
                value = values[i];

          let selected = {
            title: title,
            value: value
          }
          selectedFilters.push(selected)

        }
      }

    }
  }

  const removeFilter = (selectedFilter) => {
    let filters = {...activeFilters};

    for (const key in filters) {

      if (typeof filters[key].value == "object") {
        let filter = filters[key];
        filter.value = removeValueFromArray(selectedFilter.value, filter.value);
        filter.selectedTitles = removeValueFromArray(selectedFilter.title, filter.selectedTitles);

      } else {

        let filter = filters[key];
        if (filter.name == "search"){
          if (selectedFilter.value == filter.value){
            filter.value = "";
          }
          let es = document.getElementById("events-search");
          if (es) {
            es.value = '';
          }
        }

      }
    }
    setActiveFilters(filters)

  }


  let selected_date = "";
  if (startDate){
    selected_date = format_dates([startDate, endDate]);
  }

  let selected_top = "All";
  if (typeof activeFilters["top_filter"] != "undefined"){
     let top_filter = activeFilters["top_filter"];
     if (top_filter.value != "all"){
       top_filter.options.forEach((option) => {
         if (option.value == top_filter.value){
           selected_top = option.name;
         }
       })
     }
  }

  if (selected_top.length && selected_date.length) {
    selected_top += " - ";
  }




  return (
    <>
      <div className="filters-top">

      <div class="selected-date font-title font-l">{selected_top}{selected_date}</div>

      <FilterTotals  />

      <div className="selected-items">
        {selectedFilters.map(selectedFilter => (
          <div className="selected-item" onClick={() => removeFilter(selectedFilter)} data-filter={selectedFilter.value}>{selectedFilter.title}</div>))
        }
      </div>

      </div>
      <div className="grid">
        {pagedItems.map(item =>
          <Slot key={item.id} data={item} filterView={filterView} />
        )}
      </div>

      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={totalItems}
        pageSize={pagination.perpage}
        onPageChange={page => setCurrentPage(page)}
      />

    </>
  )
}

export default ListView;
